import { Guest, Guest as GuestModel } from '@data/models';
import { action, makeObservable, observable } from 'mobx';

export default class Guests {
  @observable main: Guest = new Guest();
  @observable additional: GuestModel[] = [];

  constructor() {
    makeObservable(this);
  }

  @action.bound updateMainGuest(guest: GuestModel) {
    this.main = guest;
  }

  @action.bound add(guest: GuestModel) {
    return this.additional.push(guest);
  }

  @action.bound update(index: number, guest: GuestModel) {
    if (this.additional.length > index) {
      this.additional[index] = guest;
    }
  }

  @action.bound remove(index: number) {
    if (this.additional.length > index) {
      this.additional.splice(index, 1);
    }
  }
}
